/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Endereco } from './types';


const getEnderecoEmpresa = (): AxiosPromise<Endereco> => xhr.get('/empresa/enderecos');

export default getEnderecoEmpresa;
